import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SubscriptionGate({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.subscription_status !== "active") {
    return <Navigate to="/subscribe" replace />;
  }
  // Redirect to onboarding if not completed yet (except when already on /onboarding)
  if (!user.onboarding_completed && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  // If onboarding already done but user lands on /onboarding, send them to dashboard
  if (user.onboarding_completed && location.pathname === "/onboarding") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
